const config = {
    // http: 'http://local-api.kyhc.top/',          // 本地环境服务
    http: 'https://api.yuyooke.com/',
    // http: 'https://api.kyhc.top',

    storageComponent: true, // 是否本地存储component
    storagePath: true // 是否本地存储路由路径
}

export default config